import React from 'react';
import { Box } from '@mui/material';

/** Buscador global por título de tarjeta, título de enlace y etiquetas. */
const GestorSearchBar = ({ query, onQueryChange }) => (
  <Box sx={{ width: '100%', minWidth: 0, position: 'relative' }}>
    <label
      htmlFor="gestor-search-input"
      style={{ position: 'absolute', width: 1, height: 1, overflow: 'hidden', clip: 'rect(0 0 0 0)' }}
    >
      Buscar enlaces o tarjetas
    </label>
    <Box
      component="svg"
      viewBox="0 0 24 24"
      fill="none"
      stroke="#5B6575"
      strokeWidth="2"
      strokeLinecap="round"
      aria-hidden="true"
      sx={{ position: 'absolute', left: '18px', top: '50%', transform: 'translateY(-50%)', width: 20, height: 20, pointerEvents: 'none' }}
    >
      <circle cx="11" cy="11" r="7" />
      <path d="M20 20l-3.5-3.5" />
    </Box>
    <Box
      component="input"
      id="gestor-search-input"
      type="search"
      autoComplete="off"
      placeholder="Buscar por tarjeta o enlace…"
      value={query}
      onChange={(event) => onQueryChange(event.target.value)}
      sx={{
        width: '100%', height: 48, boxSizing: 'border-box', padding: '0 18px 0 50px',
        fontFamily: (theme) => theme.typography.h1.fontFamily, fontSize: 16, color: '#1E2433',
        backgroundColor: '#FFFFFF', border: '1px solid #C9D2DD', borderRadius: '12px',
        transition: 'border-color 0.2s, box-shadow 0.2s',
        '&:focus': { outline: 'none', borderColor: 'primary.main', boxShadow: '0 0 0 3px rgba(0, 154, 218, 0.2)' },
      }}
    />
  </Box>
);

export default GestorSearchBar;
